export interface SidebarNavItem {
  name: string
  path: string
  module: string
}

export interface SidebarNavGroup {
  name: string
  items: readonly SidebarNavItem[]
}

export const SIDEBAR_NAV_GROUPS: readonly SidebarNavGroup[] = [
  {
    name: '计划',
    items: [
      { name: 'OKR', path: '/goals', module: 'goals' },
      { name: '待办', path: '/todo', module: 'todo' },
      { name: '日程', path: '/schedule', module: 'schedule' },
      { name: '日历', path: '/calendar', module: 'calendar' },
      { name: '会议', path: '/meeting', module: 'meeting' },
      { name: '信箱', path: '/mailbox', module: 'mailbox' },
    ],
  },
  {
    name: '记录',
    items: [
      { name: '日记', path: '/diary', module: 'diary' },
      { name: '复盘', path: '/review', module: 'review' },
      { name: '备忘录', path: '/memo', module: 'memo' },
      { name: '成长', path: '/growth', module: 'growth' },
    ],
  },
  {
    name: '健康',
    items: [
      { name: '力量', path: '/health/strength', module: 'strength' },
      { name: '跑步', path: '/health/running', module: 'running' },
      { name: '数据', path: '/health/data', module: 'health-data' },
      { name: '身体成分', path: '/health/body', module: 'body-metrics' },
    ],
  },
  {
    name: '生活',
    items: [
      { name: '旅行', path: '/travel', module: 'calendar' },
      { name: '出行清单', path: '/packing', module: 'packing' },
      { name: '纪念日', path: '/anniversaries', module: 'anniversaries' },
    ],
  },
]

export const SIDEBAR_TOOL: SidebarNavItem = {
  name: '微信同步',
  path: '/wechat-export',
  module: 'wechat-export',
}

export function isSidebarNavItemActive(currentPath: string, itemPath: string): boolean {
  return currentPath === itemPath || currentPath.startsWith(`${itemPath}/`)
}
